import {useStoryblokApi} from "@storyblok/react";
import {richTextResolver} from "@storyblok/richtext";

export default function LegacyParagraph(props: any) {
    const storyblokApi = useStoryblokApi()
    const { render } = richTextResolver()
    return <>

        <div className="rich-text"
             dangerouslySetInnerHTML={{
                 __html: render(props.blok.paragraph) as string
             }}
        >
        </div>

    </>
}